const protectionData = [
  {
    key: 0,
    question:
      "1. Responsible body and contact details of the data protection officer",
    answer: (
      <>
        <div>coming soon..</div>
      </>
    ),
  },
  {
    key: 1,
    question: "2. Purposes and legal basis of data processing",
    answer: (
      <>
        <div>
          <strong>2.1. Automatically collected access data</strong>
        </div>
        <div>
          <strong>2.2. contact</strong>
        </div>
        <div>
          <strong>2.3. Registration and login</strong>
        </div>
        <div>
          <strong>2.4. orders</strong>
        </div>
        <div>
          <strong>
            2.5. Product recommendations and existing customer advertising
          </strong>
        </div>
        <div>
          <strong>2.6. applications</strong>
        </div>
      </>
    ),
  },
  {
    key: 2,
    question: "3. Use of Cookies and Similar Technologies",
    answer: (
      <>
        <div>
          <strong>3.1. Essential tools</strong>
        </div>
        <div>3.1.1. Own cookies</div>
        <div>3.1.2. Consent manager segment</div>
        <div>3.1.3. type shape</div>
        <div>3.1.4. datadog</div>

        <div>
          <strong>3.2. Functional tools</strong>
        </div>
        <div>3.2.1. Braze</div>
        <div>3.2.2. intercom</div>
        <div>3.2.3. Optimizely</div>

        <div>
          <strong>3.3. Marketing and analytics tools</strong>
        </div>
        <div>3.3.1. Google Analytics</div>

        <div>
          <strong>3.4. Promotional tools</strong>
        </div>

        <div>3.4.1. Segment</div>
        <div>3.4.2. Facebook pixel</div>
        <div>
          3.4.3. Google Ads conversion tracking and Ads remarketing (formerly
          AdWords)
        </div>
        <div>3.4.4. Adjust</div>
        <div>3.4.5. TV Squared</div>

        <div>
          <strong>3.5. Google Maps</strong>
        </div>
      </>
    ),
  },
  {
    key: 3,
    question: "4. Sharing of Data",
    answer: (
      <>
        <div>coming soon...</div>
      </>
    ),
  },
  {
    key: 4,
    question: "5. Data transfer to third countries",
    answer: (
      <>
        <div>coming soon...</div>
      </>
    ),
  },
  {
    key: 5,
    question: "6. Duration of storage",
    answer: (
      <>
        <div>coming soon...</div>
      </>
    ),
  },
  {
    key: 6,
    question: "7. Your Rights",
    answer: (
      <>
        <div>coming soon...</div>
      </>
    ),
  },
  {
    key: 7,
    question: "8. Changes to the Privacy Policy",
    answer: (
      <>
        <div>
          <strong>
            1. Responsible body and contact details of the data protection
            officer
          </strong>
        </div>
        <div>
          We, Flink SE, are responsible for all processing of personal data in
          Germany. We are located at Brunnenstrasse 19-21 in 10119 Berlin. You
          can reach us by email at contact@goflink.com . You can reach our data
          protection officer at gdpr@goflink.com .
        </div>
        <div>
          <strong>
            1. Responsible body and contact details of the data protection
            officer
          </strong>
        </div>
        <div>
          We, Flink SE, are responsible for all processing of personal data in
          Germany. We are located at Brunnenstrasse 19-21 in 10119 Berlin. You
          can reach us by email at contact@goflink.com . You can reach our data
          protection officer at gdpr@goflink.com .
        </div>
      </>
    ),
  },
  {
    key: 8,
    question: "9. Integration of PAYBACK into DESI FRESH delivery service",
    answer: (
      <>
        <div>
          <strong>
            9.1 Use of the PAYBACK card and PAYBACK eCoupons/paper coupons as
            well as PAYBACK eVouchers
          </strong>
        </div>
        <div>
          If you are a member of PAYBACK and you have deposited your PAYBACK
          card in your DESI FRESH online account, you have the opportunity to
          collect PAYBACK points with your purchase. At the same time, you can
          redeem e-coupons, paper coupons or e-vouchers during the checkout
          process. You can find more details in the DESI FRESH online shop at
          www.DESI FRESH.de. Here, data is recorded and passed on. We refer to
          our data protection regulations as well as to the more extensive data
          protection regulations of PAYBACK .
        </div>

        <div>
          <strong>Notice to Businesses</strong>
        </div>
        <div>
          We would like to point out that the use of PAYBACK points from
          purchases for your company must be taken into account to reduce
          expenses and input tax.
        </div>

        <div>
          <strong>9.2 Special requirements for using PAYBACK e-vouchers</strong>
        </div>
        <div>
          Only five PAYBACK e-vouchers can be used per purchase. After deducting
          other discounts granted by DESI FRESH, a positive invoice amount must
          remain even after deducting the PAYBACK e-voucher. If the redemption
          of the PAYBACK e-voucher would result in a negative amount, the
          voucher is not deductible. However, the already activated e-voucher
          remains valid and can be used for the next purchase.
        </div>

        <div>
          <strong>
            9.3 Activating and Redeeming Multiple eCoupons or Paper Coupons
          </strong>
        </div>
        <div>
          It is possible to activate up to 5 PAYBACK eCoupons online when
          ordering. Later activation at the front door is not possible. However,
          the customer cannot influence the selection of the eCoupons to be
          redeemed. The combination that best suits the customer is always
          redeemed. If one or more of the items ordered by the customer cannot
          be delivered, the PAYBACK eCoupon or PAYBACK paper coupon will not be
          redeemed. The eCoupon or paper coupon remains valid.
        </div>
        <div>
          If one or more of the items ordered by the customer cannot be
          delivered or if the customer does not collect the ordered goods at the
          front door, the PAYBACK eCoupon or PAYBACK paper coupon will not be
          redeemed. The eCoupon or paper coupon remains valid.
        </div>
        <div>
          PAYBACK eCoupons and PAYBACK paper coupons have a limited period of
          validity, which is stated on the respective coupon. The corresponding
          coupon can only be used if the acceptance of the goods, and thus the
          invoicing, takes place by the specified date of validity. If payment
          is made after the validity date, the coupon cannot be redeemed.
        </div>

        <div>
          <strong>9.4</strong> DESI FRESH vouchers or PAYBACK vouchers or
          PAYBACK eCoupons must be specified online when ordering. It is not
          possible to redeem the vouchers with the driver. It is also not
          possible for the driver to scan the PAYBACK card. You can use the full
          benefits of the PAYBACK card if you store your PAYBACK card in your
          customer profile. If you do not accept individual or all goods at the
          front door, your previously activated PAYBACK vouchers and eCoupons
          will not expire. Only a previously activated voucher for the delivery
          service expires if you do not accept any goods.
        </div>
      </>
    ),
  },
  {
    key: 9,
    question: "10. Use of DESI FRESH coupons via the DESI FRESH app",
    answer: (
      <>
        <div>
          <strong>10.1</strong> If you use the DESI FRESH app when making your
          purchase via the DESI FRESH delivery service, you have the option of
          activating the DESI FRESH coupons displayed in the app and using the
          advantages of the DESI FRESH coupons. The possibility of using the
          DESI FRESH coupons is not related to participation in the Payback
          program.
        </div>
        <div>
          <strong>10.2</strong> Further information on using the DESI FRESH
          coupons can be found here or when you open the DESI FRESH app under
          “DESI FRESH Coupons – How do coupons work at DESI FRESH” and in the
          instructions for redeeming the respective coupon.
        </div>
      </>
    ),
  },
  {
    key: 10,
    question: "11. Governing Law; place of jurisdiction",
    answer: (
      <>
        <div>
          <strong>11.1 Applicability of German law</strong>
        </div>

        <div>
          German law applies exclusively to all disputes that arise in
          connection with the initiation, execution or processing of the{" "}
          <strong>
            DESI FRESH delivery service , unless mandatory consumer protection
            regulations of the country in which you have your habitual residence
            have priority.
          </strong>
        </div>
        <div>The application of the UN sales law is excluded.</div>

        <div>
          <strong>11.2 Venue Agreement</strong>
        </div>
        <div>
          If the contractual partner is a merchant, a legal entity under public
          law or a special fund under public law, our place of business
          (Cologne) is agreed as the exclusive place of jurisdiction for all
          claims arising from or on the basis of this contract. The same applies
          to persons to be sued in legal proceedings who do not have a general
          place of jurisdiction in Germany or to persons to be sued in legal
          proceedings who have moved their domicile or habitual place of
          residence outside of Germany after conclusion of the contract or whose
          domicile or habitual place of residence is in Germany The time when
          the lawsuit was filed is not known. The statutory place of
          jurisdiction for dunning proceedings is excluded from this agreement
          on place of jurisdiction.
        </div>
      </>
    ),
  },
  {
    key: 11,
    question: "12. Severability Clause",
    answer: (
      <div>
        Should individual provisions of these GTC be wholly or partially
        ineffective, the rest of the GTC shall remain effective.
      </div>
    ),
  },
  {
    key: 12,
    question: "13. Consumer Arbitration",
    answer: (
      <div>
        We hereby inform you that DESI FRESH does not participate in dispute
        settlement procedures of a consumer arbitration board within the meaning
        of the Consumer Dispute Settlement Act and is not obliged to do so.
      </div>
    ),
  },
];

export { protectionData };
